import WorldSectionLayout from "./WorldSectionLayout";
import WorldInlineQuestion from "./WorldInlineQuestion";

import CircleText from "./CircleText";
import MultiPartWidget from "./MultiPart";
import TextImageChoiceWidget from "./TextImage";
import MatchingWidget from "./Matching";
import StimulusCircleTextWidget from "./StimulusCircleText";
import MeasureClickWidget from "./MeasureClick.jsx";
import EraComposer from "./EraComposer.jsx";
import FillInBlank from "./FillInBlank.jsx";
import MultipleChoice from "./MultipleChoice.jsx";
import MatchingStacked from "./MatchingStacked.jsx";
import LetterInput from "./LetterInput.jsx";
import AnalysisInverseWidget from "./AnalysisInverse.jsx";

export default function WorldSectionRenderer({
  section,
  value = {},
  onChange,
  mode,
  feedback
}) {
  const isSingle = section.config.questions.length === 1;

  return (
    <WorldSectionLayout
      title={section.title}
      instructions={section.instructions}
      points={section.config.points}
    >
      {section.config.questions.map((q, i) => {
        const questionValue = value[q.id] ?? {};

        // ✅ FIX: slice section feedback down to question feedback
        const questionFeedback = feedback?.parts?.[q.id];

        // function setQuestionValue(v) {
        //   onChange({
        //     ...value,
        //     [q.id]: v
        //   });
        // }

        function setQuestionValue(v) {
          console.log("SECTION VALUE BEFORE:", value);
          console.log("QUESTION ID:", q.id);
          console.log("QUESTION UPDATE:", v);

          const nextSection = {
            ...value,
            [q.id]: v
          };

          console.log("SECTION VALUE AFTER:", nextSection);

          onChange(nextSection);
        }

        return (
          <WorldInlineQuestion key={q.id} number={i + 1} showNumber={!isSingle}>
            {(() => {
              switch (q.type) {
                case "circle-text":
                  return (
                    <CircleText
                      content={q.content}
                      value={questionValue}
                      onChange={setQuestionValue}
                      mode={mode}
                      feedback={questionFeedback}   // ✅
                    />
                  );

                case "measure-click":
                  return (
                    <MeasureClickWidget
                      prompt={q.prompt}
                      stimulus={q.stimulus}
                      value={questionValue}
                      onChange={setQuestionValue}
                      correct={q.correct}
                      mode={mode}
                      feedback={questionFeedback}
                    />
                  );

                case "stimulus-circle-text":
                  return (
                    <StimulusCircleTextWidget
                      stimulus={q.stimulus}
                      content={q.content}
                      correct={q.correct}
                      value={questionValue}
                      onChange={setQuestionValue}
                      mode={mode}
                      feedback={questionFeedback}
                    />
                  );

                case "multi-part":
                  return (
                    <MultiPartWidget
                      parts={q.parts}
                      value={questionValue}
                      onChange={setQuestionValue}
                      mode={mode}
                      feedback={questionFeedback}
                    />
                  );

                case "analysis-inverse":
                  return (
                    <AnalysisInverseWidget
                      definitions={q.definitions}
                      pieces={q.pieces}
                      value={questionValue}
                      onChange={setQuestionValue}
                      mode={mode}
                      feedback={questionFeedback}
                    />
                  );

                case "era-composer":
                  return (
                    <EraComposer
                      parts={q.parts}
                      composers={q.composers}
                      composerSlots={q.slots}
                      value={questionValue}
                      onChange={setQuestionValue}
                      mode={mode}
                      feedback={questionFeedback}
                    />
                  );

                case "multiple-choice":
                  return (
                    <MultipleChoice
                      parts={q.parts}
                      items={q.items}
                      value={questionValue}
                      onChange={setQuestionValue}
                      image={q.image}
                      mode={mode}
                      feedback={questionFeedback}
                    />
                  );

                case "letter-input":
                  return (
                    <LetterInput
                      parts={q.parts}
                      items={q.items}
                      legend={q.legend}
                      letters={q.letters}
                      value={questionValue}
                      onChange={setQuestionValue}
                      mode={mode}
                      feedback={questionFeedback}
                    />
                  );

                case "fill-in-blank":
                  return (
                    <FillInBlank
                      parts={q.parts}
                      questions={q.questions}
                      bank={q.bank}
                      value={questionValue}
                      onChange={setQuestionValue}
                      mode={mode}
                      feedback={questionFeedback}
                    />
                  );

                case "text-image-choice":
                  return (
                    <TextImageChoiceWidget
                      prompt={q.prompt}
                      image={q.image}
                      options={q.options}
                      betweenImage={q.betweenImage}
                      value={questionValue}
                      onChange={setQuestionValue}
                      mode={mode}
                      feedback={questionFeedback}
                    />
                  );

                case "matching":
                  return (
                    <MatchingWidget
                      blanks={q.blanks}
                      options={q.options}
                      compact={q.compact}
                      value={questionValue}
                      onChange={setQuestionValue}
                      mode={mode}
                      feedback={questionFeedback}
                    />
                  );

                case "matching-stacked":
                  return (
                    <MatchingStacked
                      blanks={q.blanks}
                      options={q.options}
                      value={questionValue}
                      onChange={setQuestionValue}
                      mode={mode}
                      feedback={questionFeedback}
                    />
                  );

                default:
                  return null;
              }
            })()}
          </WorldInlineQuestion>
        );
      })}
    </WorldSectionLayout>
  );
}

